import { useState } from "react";
import { useInventoryText } from "@/lib/inventory/i18n";
import { InventoryLabels } from "@/components/inventory/InventoryLabels";
import { InventoryScan } from "@/components/inventory/InventoryScan";
import { InventoryCounts } from "@/components/inventory/InventoryCounts";
import { InventoryOrderSerials } from "@/components/inventory/InventoryOrderSerials";
import {
  InventoryAudit,
  InventoryBoxes,
  InventoryStock,
} from "@/components/inventory/InventoryViews";
import { Loading, useInventoryAccess } from "@/components/inventory/shared";

const TABS = ["labels", "scan", "boxes", "stock", "counts", "orderSerials", "audit"] as const;

export function AdminInventory() {
  const t = useInventoryText();
  const access = useInventoryAccess();
  const [scanCode, setScanCode] = useState("");
  const [tab, setTab] = useState(() => {
    const requested = new URLSearchParams(window.location.search).get("tab");
    return TABS.find((id) => id === requested) ?? "labels";
  });
  const [initialCountId] = useState(() =>
    new URLSearchParams(window.location.search).get("count_id") ?? undefined,
  );
  if (!access.ready) return <Loading />;
  if (!access.read) return <p role="alert">{t.signIn}</p>;
  return (
    <section className="space-y-4 text-fg-primary">
      <header>
        <h1 className="text-2xl font-510">{t.title}</h1>
        <p className="text-sm text-fg-secondary">{t.intro}</p>
      </header>
      <nav
        role="tablist"
        aria-label={t.title}
        className="flex flex-wrap gap-2 border-b border-border pb-2"
      >
        {TABS.map((id) => (
          <button
            type="button"
            role="tab"
            key={id}
            aria-selected={tab === id}
            className="min-h-11 rounded px-4 py-2 hover:bg-bg-elevated"
            onClick={() => setTab(id)}
          >
            {t[id]}
          </button>
        ))}
      </nav>
      {tab === "labels" && (
        <InventoryLabels
          onScan={(id) => {
            setScanCode(id);
            setTab("scan");
          }}
        />
      )}
      {tab === "scan" && <InventoryScan initialCode={scanCode} />}
      {tab === "boxes" && (
        <InventoryBoxes
          onOpen={(id) => {
            setScanCode(id);
            setTab("scan");
          }}
        />
      )}
      {tab === "stock" && <InventoryStock />}
      {tab === "counts" && <InventoryCounts initialCountId={initialCountId} />}
      {tab === "orderSerials" && <InventoryOrderSerials />}
      {tab === "audit" && <InventoryAudit />}
    </section>
  );
}
export default AdminInventory;
